module.exports = __webpack_public_path__ + "static/media/team.00dfe30c.png";